import React from "react";
import ReactDOM from "react-dom/client";
import "./constant/importedCss";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-PZ4JB7V7", // ← استبدل بالكود الخاص بك
};
TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
